import { defineStore } from "pinia";
import {ref, computed, watch} from "vue";
import * as CmsService from "@/services/cms.service";
import {Itinerary} from "@/models/Itinerary";
import {Destination} from "@/models/Destination";
import {useLocalization} from "@/locales/localization";
import { useI18n } from 'vue-i18n';


export const useItineraryStore = defineStore('itineraries', () => {
    const loading = ref(true);
    const loadingDestinations = ref(false);
    const areas = ref<Destination[]>([]);
    const itineraries = ref<Itinerary[]>([]);
    const pages = ref<number>(1);
    const currentPage = ref<number>(1);


    const { currentLocale } = useLocalization();


    const hasItineraries = computed(() => itineraries.value.length > 0);
    
    async function getAll(page = 1, size = 10, sites = 'cosmosy', area= '', showcase = false,  options?: { splitHero?: boolean }) {
        loading.value = true;
        try {
            const { data } = await CmsService.getItineraries({ page, size, sites, area, showcase }, currentLocale.value);
            const payload = data ?? {};
            const results: Itinerary[] = payload.results ?? [];
            const splitHero = options?.splitHero ?? true;
            if (splitHero) {
                // firstPage.value = results[0];
                itineraries.value = results.slice(1);
            } else {
                // firstPage.value = undefined as unknown as Page;
                itineraries.value = results;
            }

            pages.value = Number(payload.pages ?? 1);
            currentPage.value = Number(payload.currentPage ?? page);
        } catch (e) {
            console.error('Failed to fetch pages', e);
            // firstPage.value = undefined as unknown as Page;
            itineraries.value = [];
            pages.value = 1;
            currentPage.value = 1;
        } finally {
            loading.value = false;
        }
    }

    watch(currentLocale, (newLocale, oldLocale) => {
        if (newLocale !== oldLocale) {
            getAll(currentPage.value, 10, 'cosmosy', '', false);
            getAllDestinations();
        }
    });


    // get single itinerary by slug
    function getItinerary(uuid: string) {
        return CmsService.getItinerary(uuid, "en", currentLocale.value)
    }
    
    async function getAllDestinations() {
        loadingDestinations.value = true;
        try {
            const { data } = await CmsService.getAreas(currentLocale.value);
            areas.value = data ?? [];
            return areas.value;
        } catch (e) {
            console.log('Failed to fetch areas', e);
            areas.value = [];
        } finally {
            loadingDestinations.value = false;
        }
    }
    
    
    
    function getItineraryBySlug(slug: string) {
        const itin = itineraries.value.find(i => i.slug === slug);
        return itin?.uuid ?? null;
    }
    
    function getDestination(uuid: string) {
        return CmsService.getDestination(uuid, "en", currentLocale.value)
    }
    

    return {
        loading,
        loadingDestinations,
        itineraries,
        pages,
        areas,
        hasItineraries,
        getItineraryBySlug,
        getAll,
        getItinerary,
        getAllDestinations,
        getDestination
    };
});
